import React from 'react';
import SeoHelmet from '../../../../gqlCommon/seo/SeoHelmet';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';
import useNavigationBarContext from '../../../hooks/useNavigationBarContext';

const CustomiseSeo = () => {
  const { selectedCar } = useCustomizeCarContext();
  const { selectedActiveSectionName } = useNavigationBarContext();
  const modelTitle: string = selectedCar?.car?.model?.attributes.label;
  const title: string = selectedCar?.car?.trim?.attributes.label;

  return (
    <SeoHelmet
      title="trans__configurator__seo__customise_page_title"
      description="trans__configurator__seo__customise_page_description"
      model={modelTitle}
      variant={title}
      step={selectedActiveSectionName}
    />
  );
};

export default CustomiseSeo;
